import { useTranslation } from 'react-i18next';

import { UseCaseData } from './data';

import { useEmbedding } from '@/components/embed-provider';
import { Button } from '@/components/ui/button';

const UseCase = ({
  title,
  description,
  imageUrl,
  templateId,
  actionLabel,
  onStart,
}: UseCaseData & { onStart: () => void }) => {
  const { t } = useTranslation();
  const { setEmbedState, embedState } = useEmbedding();

  const handleSelectTemplate = () => {
    setEmbedState({
      ...embedState,
      kizeoEmbed: {
        isActive: embedState.kizeoEmbed?.isActive ?? true,
        targetRoute: embedState.kizeoEmbed?.targetRoute ?? '/flows',
        language: embedState.kizeoEmbed?.language ?? 'en',
        selectedTemplateId: templateId,
      },
    });
    onStart();
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-wrap-reverse justify-center items-center gap-4 3xl:gap-8">
        <div className="max-w-[230px]">
          <p className="text-lg 3xl:text-xl leading-[1.43] font-medium mb-2 text-center sm:text-left text-balance">
            {t(title)}
          </p>
          <p className="text-sm 3xl:text-base font-light">{t(description)}</p>
        </div>
        <img src={imageUrl} alt={title} className="w-[150px] sm:w-[180px]" />
      </div>
      <Button
        className="w-fit my-6 3xl:my-8 bg-[#55c96b] enabled:hover:bg-[#55c96b]/90 text-[#011439] 3xl:text-base 3xl:px-8 3xl:py-3 3xl:h-11"
        onClick={handleSelectTemplate}
      >
        {t(actionLabel)}
      </Button>
    </div>
  );
};

export { UseCase };
